import { useRef, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { updateChannelsCurrentProgram } from 'actions/channels';
import calculateProgress from 'utils/calculate-progress';
import { AVERAGE_LIVE_LATENCY } from 'config';

const CHECK_CHANNELS_STATUS_INTERVAL = 5 * 1000; // 5 second

const useUpdateChannelsProgress = (channels, isPlayerOpen) => {
  const dispatch = useDispatch();
  const intervalRef = useRef(null);

  useEffect(() => {
    const checkChannelsStatus = () => {
      const channelsWithExpiredCurrentProgram = channels.filter((channel) => {
        const { currentProgram } = channel || {};
        if (!currentProgram) return false;
        return (
          calculateProgress(
            currentProgram.startTime,
            currentProgram.endTime,
            AVERAGE_LIVE_LATENCY,
          ) >= 1
        );
      });
      const ids = channelsWithExpiredCurrentProgram.map((channel) => channel.id);
      dispatch(updateChannelsCurrentProgram({ ids }));
    };
    // Hack didn't work out, need to fix after the EPG stub is off
    //if (isLoggedIn) checkChannelsStatus();
    if (isPlayerOpen) {
      intervalRef.current = setInterval(checkChannelsStatus, CHECK_CHANNELS_STATUS_INTERVAL);
    }
    return () => clearInterval(intervalRef.current);
  }, [channels, dispatch, isPlayerOpen]);
};

export default useUpdateChannelsProgress;
